(function() {
  'use strict';

  function initProductTabs() {
    const tabContainers = document.querySelectorAll('.product-tabs-container');
    
    tabContainers.forEach(container => {
      const tabs = container.querySelectorAll('.product-tabs-tab');
      const panels = container.querySelectorAll('.product-tabs-panel');
      
      if (!tabs.length || !panels.length) return;

      tabs.forEach(tab => {
        tab.addEventListener('click', function(event) {
          event.preventDefault();
          
          const clickedTab = event.currentTarget;
          const targetTabId = clickedTab.dataset.tab;

          // Remove active class from all tabs and panels
          tabs.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });

          panels.forEach(panel => {
            panel.classList.remove('active');
            panel.setAttribute('hidden', '');
          });

          // Add active class to clicked tab
          clickedTab.classList.add('active');
          clickedTab.setAttribute('aria-selected', 'true');

          // Show corresponding panel using block ID
          const targetPanel = container.querySelector(`#product-tab-${targetTabId}`);
          if (targetPanel) {
            targetPanel.classList.add('active');
            targetPanel.removeAttribute('hidden');
          }
        });
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }
})();


